import { render } from "./table2.vue?vue&type=template&id=63e9936a"
const script = {}

import "./table2.vue?vue&type=style&index=0&id=63e9936a&lang=css"

import exportComponent from "X:\\Proyecto\\riego-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__